/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Runbook } from "./Runbook";
export const RunbooksResponse = core.serialization.object({
    data: core.serialization.list(Runbook),
});
